/* Imports */
import React from "react"
import { Grid } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"
import GridItem from "../../components/GridItem"

import commonProps from "../../data/common-props"

const GridPage = () => {
    const items = [
        {
            content: (
                <Grid col={4} gap="m">
                    <GridItem />
                    <GridItem />
                    <GridItem />
                    <GridItem />
                    <GridItem />
                    <GridItem />
                </Grid>
            ),
            code: '<Grid col={4} gap="m">\n    \n</Grid>',
        },
    ]

    const propsItems = [
        {
            name: "col",
            type: "Number or String",
            example: "4",
            possible: (
                <>
                    1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | any value
                    for <code>grid-template-columns</code>
                </>
            ),
            default: "1",
        },
        {
            name: "gap",
            type: "String or Number",
            example: "l",
            possible: `${commonProps.spacers} | any number | any string value`,
        },
        {
            name: "columnGap",
            type: "String or Number",
            example: "xl",
            possible: `${commonProps.spacers} | any number | any string value`,
        },
        {
            name: "rowGap",
            type: "String or Number",
            example: "s",
            possible: `${commonProps.spacers} | any number | any string value`,
        },
        {
            name: "inline",
            type: "Boolean",
        },
        {
            name: "justifyItems",
            type: "String",
            example: "end",
            possible: commonProps.gridJustifyItems,
            default: "stretch",
        },
        {
            name: "alignItems",
            type: "String",
            example: "start",
            possible: commonProps.gridAlignItems,
            default: "stretch",
        },
        {
            name: "justifyContent",
            type: "String",
            example: "space-around",
            possible: commonProps.gridJustifyContent,
        },
        {
            name: "alignContent",
            type: "String",
            example: "space-between",
            possible: commonProps.gridAlignContent,
        },
        {
            name: "padding",
            type: "String or Number",
            example: "xl",
            possible: `${commonProps.spacers} | any number | any string value`,
        },
        {
            name: "colTablet",
            type: "String",
            example: "2fr 1fr",
        },
        {
            name: "colMobile",
            type: "String",
            example: "5vw 1fr 5vw",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default GridPage
